const config = {
    serverUrl: 'https://api.izolacjaokien.pl',
};

export default config;
